import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { CreditCardTypeSchema } from './credit-card-type.ts'

export const BillingServiceCreditCardSchema = z.object({
  brand: CreditCardTypeSchema,
  last4: z.string(),
  exp_month: z.number(),
  exp_year: z.number(),
})

export type BillingServiceCreditCard = ZodInfer<
  typeof BillingServiceCreditCardSchema
>
